/**
 * Shared storage key prefixes for localStorage and sync metadata.
 */
export const STORAGE_KEYS = {
  E2E_SETUP_PREFIX: 'deckle_e2e_setup_',
  LAST_SYNCED_PREFIX: 'deckle_last_synced_',
  LAST_SYNCED_HASH_PREFIX: 'deckle_last_synced_hash_',
  LAST_SYNC_TIME: 'deckle-last-sync-time',
  CLOUD_RECOVERY_DISMISSED: 'deckle-cloud-recovery-dismissed',
} as const;

/** Get the localStorage key for a user's E2E setup status */
export function getE2ESetupKey(userId: string): string {
  return `${STORAGE_KEYS.E2E_SETUP_PREFIX}${userId}`;
}

/** Get the localStorage key for a manuscript's last synced timestamp */
export function getLastSyncedKey(manuscriptId: string): string {
  return `${STORAGE_KEYS.LAST_SYNCED_PREFIX}${manuscriptId}`;
}

/** Get the localStorage key for a manuscript's last synced hash */
export function getLastSyncedHashKey(manuscriptId: string): string {
  return `${STORAGE_KEYS.LAST_SYNCED_HASH_PREFIX}${manuscriptId}`;
}

/** Get the localStorage key for a manuscript's per-entity synced hashes (smart merge) */
export function getEntityHashesKey(manuscriptId: string): string {
  return `deckle_entity_hashes_${manuscriptId}`;
}
